import React from "react";
import "../Styles/Footer.css";

import bgImage from "../Assets/bg10.jpg"; // your background image
import { HashLink } from "react-router-hash-link";

// Social media icons as images
import facebookIcon from "../Assets/fb.jpeg";
import instagramIcon from "../Assets/instagram.jpeg";
import twitterIcon from "../Assets/twitter.png";
import whatsappIcon from "../Assets/whatsapp.jpeg";

const Footer = () => {
  return (
    <>
      <footer
        className="footer"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="footer-overlay">
          <div className="footer-container">
            {/* Navigation */}
            <div className="footer-col">
              <h4>Navigation</h4>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/aboutus">About</a></li>
              <li><HashLink smooth to="/#awards">Awards</HashLink></li>
                <li><HashLink smooth to="/#works">Works</HashLink></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/contactpg">Careers</a></li>
                <li><a href="/blog">Blog</a></li>
                <li><a href="/contactpg">Contact</a></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer-col">
              <h4>Services</h4>
              <ul>
                <li><a href="/services">Web Development</a></li>
                <li><a href="/services">UX Design</a></li>
                <li><a href="/services">Ads Promotion</a></li>
                <li><a href="/services">Digital Marketing</a></li>
                <li><a href="/services">Branding</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col contact">
              <h4>Contact Us</h4>
              <p>
                📧{" "}
                <a href="mailto:info@dddigitalconstruction.com">
                  info@dddigitalconstruction.com
                </a>
              </p>
              <p>
                📞{" "}
                <a href="tel:+916380764850">
                  +91 6380764850
                </a>
              </p>
              <div className="social-icons">
                <a href="https://wa.me/+916380764850" target="_blank" rel="noreferrer">
                  <img src={whatsappIcon} alt="WhatsApp" />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noreferrer">
                  <img src={facebookIcon} alt="Facebook" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer">
                  <img src={instagramIcon} alt="Instagram" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer">
                  <img src={twitterIcon} alt="Twitter" />
                </a>
              </div>
            </div>

            {/* Newsletter */}
            <div className="footer-col newsletter">
              <h4>Newsletter</h4>
              <div className="newsletter-box">
                <input type="email" placeholder="Your Email address" />
                <button>Subscribe Now!</button>
              </div>
              <p>Enter your email ID above to subscribe to our newsletter.</p>
              <div className="awards">
                <p>🏆 3 Awards</p>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              ©2025 All rights reserved to <b>DD Digital Construction</b> | Terms & Conditions | Privacy Policy
            </p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/+916380764850"
        target="_blank"
        rel="noreferrer"
        className="floating-whatsapp"
      >
        <img src={whatsappIcon} alt="WhatsApp" />
      </a>
    </>
  );
};

export default Footer;
